import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  leaveLeague: {
    id: 'Settings.leaveLeague',
    defaultMessage: 'Leave league',
  },
  leaveLeagueMessage: {
    id: 'Settings.leaveLeagueMessage',
    defaultMessage:
      'Are you sure you want to leave this league? All your scores will be lost.',
  },
  deleteLeague: {
    id: 'Settings.deleteLeague',
    defaultMessage: 'Delete league',
  },
  deleteLeagueMessage: {
    id: 'Settings.deleteLeagueMessage',
    defaultMessage:
      'Are you sure you want to delete this league? All scores will be lost.',
  },
});
